import { useForm } from '@inertiajs/react'
import AuthLayout from '@/layouts/AuthLayout'
import type { FormEvent } from 'react'

interface ResetPasswordProps {
  token: string
}

export default function ResetPassword({ token }: ResetPasswordProps) {
  const { data, setData, patch, processing } = useForm({
    token,
    password: '',
    password_confirmation: '',
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    patch('/reset_password')
  }

  return (
    <AuthLayout title="Choose a new password">
      <div className="card bg-base-100 shadow-lg">
        <div className="card-body">
          <h2 className="card-title text-2xl font-bold mb-4">Choose a new password</h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            <fieldset className="fieldset">
              <legend className="fieldset-legend">New password</legend>
              <input
                type="password"
                className="input w-full"
                value={data.password}
                onChange={(e) => setData('password', e.target.value)}
                required
                autoFocus
                minLength={8}
                autoComplete="new-password"
              />
            </fieldset>

            <fieldset className="fieldset">
              <legend className="fieldset-legend">Confirm new password</legend>
              <input
                type="password"
                className="input w-full"
                value={data.password_confirmation}
                onChange={(e) => setData('password_confirmation', e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
              />
            </fieldset>

            <button
              type="submit"
              className="btn btn-primary w-full"
              disabled={processing}
            >
              {processing && <span className="loading loading-spinner loading-sm" />}
              Reset password
            </button>
          </form>
        </div>
      </div>
    </AuthLayout>
  )
}
